import React from "react";
import { ReactComponent as AccountSVG } from "../static/icons/account.svg";
import { Link, useNavigate } from "react-router-dom"
import { useSelector } from "react-redux";

function NavbarDesktop() {
    const signedIn = useSelector(state => state.user.signedIn)
    const navigate = useNavigate();

    return (
        <nav className="navbar mobile-hidden">
            <div>
                <div className="flex flex-row items-center navbar-links m-2">
                    <Link to="/" className="navlink mx-4">Home</Link>
                    {signedIn && <Link to="/app/breaks" className="navlink mx-4">Breaks</Link>}
                    {/* {signedIn && <Link to="/app/map" className="navlink mx-4">Map</Link>}
                    {signedIn && <Link to="/app/buoys" className="navlink mx-4">Buoys</Link>} */}
                    <Link to="/about" className="navlink mx-4">About</Link>
                </div>
            </div>
            <div><p className="navbar-logo font-bold">Surf Journal</p></div>
            {signedIn ? <div onClick={() => navigate("/app/account")}><AccountSVG className="navbar-icon"/></div> : <div><Link to="/login" className="navlink mx-4 float-right">Login</Link></div>}
        </nav>
    );
}

export default NavbarDesktop;

//{{textDecoration:"none", color:"black"}}